import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Divider } from "@material-ui/core";

import { savePaymentMethod } from "../redux/cartRedux";
import { PAYMENT_METHODS } from "../config/market";
import Navbar from "../components/Navbar";
import styled from "styled-components";

const PaymentContainer = styled.div`
  width: 100vw;
  min-height: 100vh;
  background-color: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 20px;
  margin-top: 30px;

  @media (max-width: 768px) {
    padding: 20px 15px;
  }
`;

const PaymentCard = styled.div`
  max-width: 550px;
  width: 90%;
  padding: 2.5rem;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1;

  @media (max-width: 768px) {
    padding: 2rem;
    width: 95%;
  }

  @media (max-width: 480px) {
    padding: 1.5rem;
  }
`;

const PaymentTitle = styled.h1`
  font-size: 28px;
  font-weight: 700;
  text-align: center;
  color: #334d55;
  margin-bottom: 1.5rem;
  letter-spacing: 1px;
  text-transform: uppercase;

  @media (max-width: 480px) {
    font-size: 22px;
  }
`;

const StyledDivider = styled(Divider)`
  && {
    background-color: #334d55;
    height: 2px;
    margin: 1rem 0 1.5rem 0;
  }
`;

const PaymentLabel = styled.label`
  display: block;
  margin-bottom: 1.2rem;
  margin-top: 1.5rem;
  font-size: 18px;
  font-weight: 600;
  color: #4A4A4A;
  letter-spacing: 0.5px;

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

const PaymentOptionButton = styled.button`
  border: none;
  padding: 16px 32px;
  background-color: #334d55;
  color: white;
  cursor: pointer;
  margin-top: 1.5rem;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  transition: all 0.2s ease;

  &:hover {
    background-color: #2a3f46;
  }

  &:active {
    transform: translateY(1px);
  }

  &:disabled {
    background-color: #ccc;
    color: #666;
    cursor: not-allowed;
  }

  @media (max-width: 480px) {
    padding: 14px 28px;
    font-size: 14px;
    width: 100%;
  }
`;

const PaymentScreen = () => {
  const { products } = useSelector((state) => state.cart);
  const [selectedOption, setSelectedOption] = useState(-1);

  const dispatch = useDispatch();
  const history = useHistory();

  // if there are no products, redirect to cart page
  useEffect(() => {
    if (products.length === 0) {
      history.push("/cart");
    }
  }, [history, products]);

  const submitHandler = (e) => {
    e.preventDefault();
    // Method keys come from the ACTIVE market's registry (config/market.js):
    // UG keeps MOMO/Airtel/Visa/COD byte-for-byte; ZM adds ZAMTEL and routes
    // its mobile money over the Flutterwave rail at place-order time.
    dispatch(savePaymentMethod(paymentOptions[selectedOption].key));
    history.push("/placeorder");
  };

  const handleOptionChange = (index) => {
    setSelectedOption(index);
  };

  const paymentOptions = PAYMENT_METHODS;

  const optionStyle = (isSelected) => ({
    display: "flex",
    alignItems: "center",
    gap: "16px",
    padding: "16px 20px",
    borderRadius: "12px",
    cursor: "pointer",
    backgroundColor: isSelected ? "#e8f4f8" : "#f5f7fa",
    transition: "all 0.2s ease",
    textAlign: "center",
    fontWeight: isSelected ? "600" : "500",
    marginBottom: "12px",
    height: "70px",
    border: isSelected ? "2px solid #334d55" : "2px solid #e0e0e0",
  });

  return (
    <>
      <Navbar />
      <PaymentContainer>
        <PaymentCard>
          <PaymentTitle>Payment Options</PaymentTitle>
          <StyledDivider />
          <form>
            <PaymentLabel>
              Select Payment Method
            </PaymentLabel>
            {paymentOptions.map(({ key, label, imageUrl }, index) => (
              <div
                key={key}
                style={optionStyle(selectedOption === index)}
                onClick={() => handleOptionChange(index)}
              >
                {imageUrl ? (
                  <img
                    src={imageUrl}
                    alt={label}
                    style={{ width: "50px", height: "44px", marginRight: "5px" }}
                  />
                ) : (
                  <div style={{ width: "50px", height: "44px", marginRight: "5px" }} />
                )}
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    borderRadius: "50%",
                    border:
                      selectedOption === index
                        ? "3px solid #334d55"
                        : "2px solid #D1D5DB",
                    backgroundColor:
                      selectedOption === index ? "#334d55" : "transparent",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "8px",
                    transition: "all 0.3s",
                    boxShadow: selectedOption === index ? "0 0 10px rgba(51, 77, 85, 0.5)" : "none",
                  }}
                >
                  {selectedOption === index && (
                    <div
                      style={{
                        width: "10px",
                        height: "10px",
                        borderRadius: "50%",
                        backgroundColor: "white",
                      }}
                    ></div>
                  )}
                </div>
                {label}
              </div>
            ))}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "1rem",
              }}
            >
              <PaymentOptionButton
                disabled={selectedOption === -1}
                onClick={submitHandler}
              >
                Continue
              </PaymentOptionButton>
            </div>
          </form>
        </PaymentCard>
      </PaymentContainer>
    </>
  );
};

export default PaymentScreen;
